import styled from 'styled-components';
import bgImg from '../../images/workshop.jpg';

export const Container = styled.div`
  position: relative;
  width: 100%;
  margin: 0 auto;
  background-image: url(${bgImg});
  background-size: cover;
  .work-page-row {
    position: relative;
    max-width: ${props => props.theme.maxWidth};
    margin:auto;
    background: rgba(255, 255, 255, 0.9);
    padding: 1em;
    border-radius: 20px;
    transition: left 0.8s ease;
    left: ${props => props.viewable ? 0 : -100 }%;
  }
  .work-page-col {
    padding: 20px;
    h2 {
      font-size: 1.8em;
       margin: 0;
    }
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const Title = styled.h1`
  font-size: 1.5em;
  font-weight: 400;
  margin: 0 auto;
  padding: 4.5em 1em 1em;
  max-width: ${props => props.theme.maxWidth};
  @media (min-width: 768px) {
    font-size: 2.25em;
  }
`;



// WEBPACK FOOTER //
// ./src/components/WorkPage/Styles.js